import { IFiltroEventoEscala } from '../../models/escala.filtros.model';

export class MeurhEscalaConfigVisualizacaoModalController {
  static $inject = ['$uibModalInstance', 'entity'];

  constructor(
    public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
    public entity: IFiltroEventoEscala
  ) {}

  ok() {
    this.$uibModalInstance.close(this.entity);
  }

  close() {
    this.$uibModalInstance.dismiss('fechar');
  }
}
